<div class="info-text">
    <span i18n="End of year|info text|About dividends and annual report" *ngIf="showFullText">About dividends and annual report</span>
    <span i18n="End of year|info text|About annual report, the board and signing" *ngIf="stepIsBoardMemberInformation">About annual report, the board and signing</span>
    <a class="read-about-link" target="_blank" href="{{endOfYearDividendsAndAnnualReportLink}}" i18n="End of year|link text|Read about dividends and annual report">Read about dividends and annual report</a>
</div>
